@let gridData = $gridData();
@let T = gridData.data;

<unity-grid-shared
  gridTitle="Documents"
  [gridData]="$gridData()"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/agreement', item.agreement.id, 'document', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="created_dt" title="Added On" filter="date">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      {{ item.created_dt | dateTimezone }}
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="parent_document.name" title="Amendment To">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      @if (item.parent_document) {
        <unity-link-gridcell-shared
          [displayText]="item.parent_document.name"
          [link]="['/agreement', item.agreement.id, 'document', item.parent_document.id]" />
      } @else {
        (None)
      }
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
